module.exports = __webpack_public_path__ + "img/login-image.37856928.jpg";